import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DxauthService } from 'src/app/dxauth.service';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import { Auth0Service } from 'src/app/shared/services/auth0.service';
import { GtmService } from 'src/app/shared/services/gtm.servie';
import { environment } from 'src/environments/environment';
import { RegisterInput } from './components/form/types';
import { prefectures } from './const';

@Component({
  selector: 'app-lasuite-register',
  templateUrl: './lasuite-register.component.html',
  styleUrls: ['../style/global.css', './lasuite-register.component.css'],
})
export class LasuiteRegisterComponent
  extends BaseLoginComponent
  implements OnInit
{
  public acceptTerm = false;
  public acceptPrivacyPolicy = false;
  // typo, 他ページとのページとの互換性のため維持
  isRegistable = true;
  public initialized: boolean = true;
  gtmService: GtmService;

  genders = [
    {
      label: '男性',
      value: 'male',
    },
    {
      label: '女性',
      value: 'female',
    },
  ];

  prefectures = [{ label: '都道府県を選択', value: 'undefined' }].concat(
    prefectures.map((prefecture) => ({
      label: prefecture,
      value: prefecture,
    }))
  );

  params: {
    prefecture?: string;
    zipcode: string;
    city?: string;
    address?: string;
    building?: string;
    town?: string;
    birthdate: {
      year?: string;
      month?: string;
      date?: string;
    };
  } = {
    zipcode: '',
    birthdate: {},
  };

  constructor(
    activateRoute: ActivatedRoute,
    auth0: Auth0Service,
    dxauth: DxauthService,
    spinner: NgxSpinnerService,
    public router: Router,
    public title: Title,
    gtmService: GtmService
  ) {
    super(activateRoute, auth0, dxauth, spinner, router, title);
    this.gtmService = gtmService;
    // this.masterData.years.push({ label: '年', value: undefined }); // 降順にするのでこちらだけpush
    // this.masterData.month.unshift({ label: '月', value: undefined });
    // this.masterData.dates.unshift({ label: '日', value: undefined });
  }

  async ngOnInit() {
    const gtmId = environment.apps[this.clientId].gtm?.id;
    if (gtmId) {
      this.gtmService.setGtmId(gtmId);

      this.gtmService.addGtmToDom();
    }
  }

  async init(): Promise<void> {}

  get baseLink() {
    return environment.apps[this.clientId].appUrl;
  }

  get isOem() {
    return /oem/g.test(environment.apps[this.clientId].type);
  }

  get oemId() {
    return environment.apps[this.clientId].oemConfig?.id;
  }

  get privacyUrl() {
    return environment.apps[this.clientId].privacyUrl;
  }

  get termsUrl() {
    return environment.apps[this.clientId].termUrl;
  }

  get appname() {
    return 'うめきた温泉蓮';
  }

  /** 登録時のロール. 基本的に患者ロールのみ */
  registrationRole() {
    return 'patient';
  }

  async register() {
    // プロフィール情報の設定. gender, birthdate以外はロールごとのプロフィールになるのでprofile属性で設定
    const profile: { label: string; name: string; value: unknown }[] = [
      { label: '郵便番号', name: 'zipcode', value: this.params.zipcode },
      { label: '都道府県', name: 'prefecture', value: this.params.prefecture },
      { label: '市区町村', name: 'city', value: this.params.city },
      { label: '建物名', name: 'building', value: this.params.building },
      { label: '町名', name: 'town', value: this.params.town },
    ];

    // 生年月日の設定. ハイフン区切りに組み立てる
    this.birthDate = `${this.params.birthdate.year}-${this.params.birthdate.month}-${this.params.birthdate.date}`;
    // バリデーション
    if (!this.submittable()) {
      return undefined;
    }

    return super.register({
      profile: JSON.stringify(profile),
    });
  }

  async onSubmit(input: RegisterInput) {
    // 暫定対応：既存のページと動作を合わせるためにここで各値を設定する

    // TODO?: 語彙が統一されていない
    this.lastName = input.familyName;
    this.firstName = input.givenName;

    this.email = input.email;

    this.password = input.password.rawPassword;
    this.confirmPassword = input.password.confirmPassword;

    this.params.birthdate.year = input.birthDate.year;
    this.params.birthdate.month = input.birthDate.month;
    this.params.birthdate.date = input.birthDate.date;

    this.gender = input.gender;

    this.params.zipcode = input.zipcode;

    this.params.prefecture = input.address.prefecture;
    this.params.city = input.address.city;
    this.params.town = input.address.town;
    this.params.building = input.address.building;

    this.acceptTerm = input.acceptTerm;

    //
    await this.register();
  }

  // 親クラスのメソッドをオーバーライド
  // レスポンス由来のエラーだけリセットする
  // バリデーションはフォームコンポーネント側で行う
  submittable() {
    this.errorMessages.signup = {} as any;
    return true;
  }
}
